export default __webpack_public_path__ + "7de2369cb0a73bbce6e95a6d2e94dc57.svg";